import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  affiliate: {},
  affiliates: [],
};

export const affiliateSlice = createSlice({
  name: "affiliate",
  initialState,
  reducers: {
    setaffiliate: (state, { payload }) => {
      return {
        ...state,
        affiliate: payload,
      };
    },
    removeAffiliate: (state, { payload }) => {
      return {
        ...state,
        ...initialState,
        affiliate: {},
      };
    },
    setAffiliateList: (state = initialState, { payload }) => {
      return {
        ...state,
        affiliates: payload,
      };
    },
  },
});
